import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../Components/Base/Tabs';
import PaymentDetails from '../Components/Calculator/PaymentDetails';
import InterfaceStorage from '../Components/Site/InterfaceStorage';
import Interface from '../Components/Site/Interface';
import MortgageCost from '../Components/Calculator/MortgageCost';
import MortgageCredit from '../Components/Calculator/MortgageCredit';
import MortgageService from '../Components/Calculator/MortgageService';
import MortgageSalary from '../Components/Calculator/MortgageSalary';

export default class CalculatorWidget extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = {
            paymentDetails: React.createRef(),
        };

        this.state = {
            tabTitles: null,
            visible: true,
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // INIT
    //------------------------------------------------------------------------------------------------------------------
    
    static get propTypes() {

        return {

            /**
             * @var {string} type
             * calculator type
             * list of available values in a getSupportedTypes method
             */
            type: PropTypes.oneOf(CalculatorWidget.getSupportedTypes()).isRequired,

            /**
             * @var {object} query
             * original query by generate calculator report
             * 
             * the query struct:
             * @property {integer} calculatorId source calculator entity id
             * @property {integer} countryId source country entity id
             * @property {object} currency symbol and iso required
             * @property {string} calculatorType reserved, not used now
             */
            query: PropTypes.object.isRequired,

            /**
             * @var {string} className
             * component extra classes
             */
            className: PropTypes.string,
        };
    }

    static getSupportedTypes() {

        return [
            'mortgage',
        ];
    }

    componentDidMount() {

        if (!this.state.tabTitles) {

            this.setState({
                tabTitles: [
                    Interface.get(InterfaceStorage.COUNTRY, 'mortgageTabLabel1'),
                    Interface.get(InterfaceStorage.COUNTRY, 'mortgageTabLabel2'),
                    Interface.get(InterfaceStorage.COUNTRY, 'mortgageTabLabel3'),
                    Interface.get(InterfaceStorage.COUNTRY, 'mortgageTabLabel4', false, false),
                ],
            });
        }

        this.details = <PaymentDetails
            ref={ this.nodes.paymentDetails }
            countryId={ this.props.query.countryId }
            currency={ this.props.query.currency } />;
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        if (!this.state.tabTitles || !this.state.tabTitles[0])
            return null;
        // render only after titles are received
        // (otherwise, incorrect IDs for tabs will be generated)

        const props = {
            from: this.getOriginPath(),
            query: this.props.query,
        };
        // prepare props by calcs

        return (<>

            <Tabs onChange={ (e) => this.tabChangeEvent(e) } changeTabByHash={ true }>
                
                <div title={ this.state.tabTitles[0] } id='property'>
                    <MortgageCost onSubmit={ (e) => this.submitEvent(e) } {...props} />
                </div>
                
                <div title={ this.state.tabTitles[1] } id='loan'>
                    <MortgageCredit onSubmit={ (e) => this.submitEvent(e) } {...props} />
                </div>

                <div title={ this.state.tabTitles[2] } id='costs'>
                    <MortgageService onSubmit={ (e) => this.submitEvent(e) } {...props} />
                </div>

                { this.renderOptionalCalculators(props) }

            </Tabs>
            
            { this.renderPaymentsDetails() }

        </>);
    }

    renderOptionalCalculators(props) {

        if (!this.state.tabTitles[3])
            return null;

        return (
            <div title={ this.state.tabTitles[3] } id='salary'>
                <MortgageSalary onSubmit={ (e) => this.submitEvent(e) } {...props} />
            </div>
        );
    }

    renderPaymentsDetails() {
        
        return this.state.visible
            ? this.details
            : null;
    }

    //------------------------------------------------------------------------------------------------------------------
    // EVENTS
    //------------------------------------------------------------------------------------------------------------------

    tabChangeEvent(e) {

        const form = e.detail.target.querySelector('form');
        if (form && form.response) {

            if (!this.state.visible)
                this.setState({ visible: true });

            document.dispatchEvent(new CustomEvent('DOMContentUpdated', {
                detail: { target: form },
            }));

            this.nodes.paymentDetails.current?.update(form.response.report);
        }
        else {
            
            if (this.state.visible)
                this.setState({ visible: false });
        }
    }

    submitEvent(e) {

        if (Tabs.hasActiveContainer(e.detail.target))
            this.nodes.paymentDetails.current?.update(e.detail.response.report);
    }

    //------------------------------------------------------------------------------------------------------------------
    // GETTER / SETTERS
    //------------------------------------------------------------------------------------------------------------------

    getOriginPath() {

        return window.location.path;
    }

}